import React from "react";

const ClockIcon: React.FC<{
  className?: string;
  color?: string;
  width?: number;
  height?: number;
}> = ({
  className,
  color = "#545454", // Default fill color
  width = 12,
  height = 12,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 2.57143H5.14286V6.85714H9.42857V6H6V2.57143Z" fill={color} />
      <path
        d="M0 6C0 2.68661 2.68661 0 6 0C9.31339 0 12 2.68661 12 6C12 9.31339 9.31339 12 6 12C2.68661 12 0 9.31339 0 6ZM0.857143 6C0.857143 8.83661 3.16339 11.1429 6 11.1429C8.83661 11.1429 11.1429 8.83661 11.1429 6C11.1429 3.16339 8.83661 0.857143 6 0.857143C3.16339 0.857143 0.857143 3.16339 0.857143 6Z"
        fill={color}
      />
    </svg>
  );
};

export default ClockIcon;
